module.exports = __webpack_public_path__ + "img/jacket-front-detail.b267e327.jpg";